<template>
  <div class="w-full bottom-0 m-0">
    <footer class="w-full bg-theme-19 text-white text-center px-12 py-8">
      <div class="grid grid-cols-3 gap-4">
        <div class="col-span-3 sm:col-span-1">
          <img
            v-if="urlOriginIsBrandIn"
            :src="require(`@/assets/images/COT-img/logo-brand-in-white.png`)"
            alt="logo"
            class="sm:m-2 m-auto w-48 sm:w-48"
          />
          <img
            v-else
            :src="require(`@/assets/images/COT-img/logo-white.svg`)"
            alt="logo"
            class="sm:m-2 m-auto w-48 sm:w-48"
          />
        </div>
        <div class="col-span-3 sm:col-span-1">
          <div class="grid grid-cols-3 gap-1 w-48 m-auto">
            <div class="m-auto">
              <img
                :src="
                  require(`@/assets/images/COT-bg/redes-sociales/facebook.svg`)
                "
                alt="face"
              />
            </div>
            <div class="m-auto">
              <img
                :src="
                  require(`@/assets/images/COT-bg/redes-sociales/instagram.svg`)
                "
                alt="insta"
              />
            </div>
            <div class="m-auto">
              <img
                :src="
                  require(`@/assets/images/COT-bg/redes-sociales/youtube.svg`)
                "
                alt="yt"
              />
            </div>
          </div>
        </div>
        <div class="col-span-3 sm:col-span-1 text-center sm:text-left m-auto">
          <div class="text-base font-normal hover:text-theme-29 font-poppins">
            <router-link
              :to="{ name: 'contact' }"
              tag="a"
              class="cursor-pointer"
            >
              Contacto
            </router-link>
          </div>
          <div class="text-base font-normal hover:text-theme-29 font-poppins">
            <router-link
              :to="{ name: 'privacity' }"
              tag="a"
              class="cursor-pointer"
            >
              Aviso de privacidad
            </router-link>
          </div>
          <div class="text-base font-normal hover:text-theme-29 font-poppins">
            <router-link
              :to="{ name: 'conditions' }"
              tag="a"
              class="cursor-pointer"
            >
              Términos y condiciones
            </router-link>
          </div>
        </div>
      </div>
    </footer>
    <div class="text-center bg-theme-20 text-white p-2 font-poppins">
      Todos los derechos reservados
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    urlOriginIsBrandIn() {
      const currentHost = (window.location?.host || '').replace(/^www\./, '')
      const brandInDomain = (process.env.VUE_APP_BRAND_IN_DOMAIN || '').replace(
        /^www\./,
        ''
      )
      return currentHost === brandInDomain
    }
  }
}
</script>
<style scoped></style>
